import { LOAD_ACCOUNTS_SUCCESS, LOAD_ACCOUNTS_FAILED, UPDATE_CURRENT_ACCOUNT, PAID_ACCCOUNT, IS_IE } from "./actionType";
import { enableLoader, disableLoader, disableLoaderWithError} from "./uiActions";
import axios from "axios";

let ACCOUNTS_URL;
if(sessionStorage.getItem('app_info')){
	ACCOUNTS_URL = JSON.parse(sessionStorage.getItem('app_info')).ACCOUNTS_URL;
}


//Utility function to get the URL string
function getURL(accountNumber: string, zip: string) {
	return (
		`${ACCOUNTS_URL}/getBillingDetails?billing_account_number=${
		accountNumber.replace(" ", "")}&billing_zipcode=${
		zip}`
	);
}


export const clearUserData = () =>{
    return { type: PAID_ACCCOUNT };
}

export const loadAccountsSuccess = (accounts,pcgx) => {
	return { type: LOAD_ACCOUNTS_SUCCESS, accounts ,pcgx};

}
export const loadAccountsFailed = errorInfo => {
	return { type: LOAD_ACCOUNTS_FAILED, errorInfo };
}


export const updateAccountPayment = (accountUpdate) => {
	return { type: UPDATE_CURRENT_ACCOUNT, accountUpdate };
}

export const isIEFlag = (isIEFlag) => {
	return { type: IS_IE, isIEFlag }
}

export const loadAccounts = (accountNumber: string, zip: string, history: object,pcgx) => {
	return dispatch => {
		dispatch(enableLoader());
		// window._satellite.track("AccountSubmitted")
		return axios
			.get(getURL(accountNumber, zip))
			.then(res => {
				if(res.data.accounts.length===0){
					dispatch(disableLoaderWithError());
					dispatch(loadAccountsFailed({
						"code": "404",
						"message": "We can't find that Billing Account. Please try again, or use the \"?\" Tool Tip to see where the Billing Account number is on your printed invoice."
					}));
				}
				else{
					//disable the loader
					dispatch(disableLoader());
					if(pcgx){
						dispatch(loadAccountsSuccess(res.data,true));
					}

					//save accounts in state
					// window._satellite.track("AccountValidated")
					else	dispatch(loadAccountsSuccess(res.data,false));

					/*HACK: I had to pass history object as a prop from Login Page
					Don't know why the History from react router package isn't working (SEE TOP) correctly
					This hack will do.
					*/
					history.push("/accounts");
				}

			})


			.catch(error => {
				dispatch(disableLoaderWithError());
				if (error.response) {
					dispatch(loadAccountsFailed({
						"code": error.response.status,
						"message": error.response.data.message
					}));
					history.push('/error');

				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js


					dispatch(loadAccountsFailed({
						"code": "N404",
						"message": "Network Error"
					}));

					history.push('/error');

				} else {
					// Something happened in setting up the request that triggered an Error
					dispatch(loadAccountsFailed({
						"code": "E405",
						"message": "We are experiencing some technical issues."
					}));

					history.push('/error');

				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/actions/accountActions.js